




import { Component, Vue, Prop } from 'vue-property-decorator';
import { Approval } from '@/models/approval';

@Component
export default class ApprovalStatusLabel extends Vue {
    @Prop({ required: true }) public approval: Approval;

    public get className(): { [key: string]: boolean } {
        switch (this.approval.status) {
        case 0:
            return { 'label-warning': true };
        case 1:
            return { 'label-success': true };
        case 2:
            return { 'label-danger': true };
        default:
            return { 'label-default': true };
        }
    }
    public get description(): string {
        switch (this.approval.status) {
        case 0:
            return `Pending`;
        case 1:
            return `Accepted`;
        case 2:
            return `Rejected`;
        default:
            return `Unknown`;
        }
    }
}
